import * as t from 'react';
import { forwardRef, memo } from 'react';

var m=({title:e,titleId:r,...a},o)=>t.createElement("svg",{xmlns:"http://www.w3.org/2000/svg",viewBox:"0 0 16 16",fill:"currentColor",ref:o,"aria-labelledby":r,...a},e?t.createElement("title",{id:r},e):null,t.createElement("path",{d:"M8 1a7 7 0 1 0 5 2.05A7 7 0 0 0 8 1m0 13a6 6 0 1 1 4.24-1.76A6 6 0 0 1 8 14","data-name":"Path 19"}),t.createElement("path",{d:"M7 10.77 5.25 9.11l.56-.55 1.13 1.07 3.48-4.09.61.51Z","data-name":"Path 20"})),n=forwardRef(m),f=memo(n),d=f;

export { d as a };
//# sourceMappingURL=out.js.map
//# sourceMappingURL=chunk-UCL4WGIN.mjs.map